import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importar archivos de traducción por página
import es404 from "./locales/pages/es/404.json";
import en404 from "./locales/pages/en/404.json";
import esCall from "./locales/pages/es/call.json";
import enCall from "./locales/pages/en/call.json";
import esSchedule from "./locales/pages/es/schedule.json";
import enSchedule from "./locales/pages/en/schedule.json";

const resources = {
  es: {
    "404": es404,
    call: esCall,
    schedule: esSchedule,
  },
  en: {
    "404": en404,
    call: enCall,
    schedule: enSchedule,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es", // Idioma por defecto
    debug: false, // Cambiar a true para desarrollo

    detection: {
      // Solo detectar idioma del navegador en la página 404
      // En otras páginas se usará assistantData.language
      order: ["navigator", "htmlTag"],
      // Sin caché en localStorage: si el navegador tiene bloqueados los datos
      // del sitio, el acceso lanza SecurityError durante este init — que corre
      // al importar el módulo, antes de que React monte — y la app no arranca.
      caches: [],
    },

    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
  });

export default i18n;
